import axios, { GET, POST } from './axios';


export function updateCartWarranty(reqBody) {
  return axios({
    method: POST,
    url: `insightweb/transaction/updateCartWarranty`,
    data: reqBody
  }).catch((error) => {
    console.warn('Error while updating the cartWarrenties: ' + error)
    throw error
  })
}
